import TransactionList from "../components/Tansactions/TransactionList";

const Transactions = () => {
	return <TransactionList />;
};

export default Transactions;
